// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"965a4c99","468":"965a4c99","681":"965a4c99","693":"965a4c99","777":"965a4c99","821":"88d98234","904":"e7e68df8","917":"965a4c99"}[chunkId] + ".chunk.css";
};